module.exports = __webpack_public_path__ + "static/SVHome-03-17b224992ec8cf76fd1c4ee1f249ee43.png";